import React from "react";

import { AlignVAT } from "@vp/ep-pricing";
import { PriceQuery } from "../../store/productPriceDetails.types";
import { PricePresentationType } from "../../types/prices";
import { DisplayVariant, PriceDisplayType, SelectionsWithQuantity } from "../../types/pricing/price-display.types";
import { PricingInfo } from "../../types/tieredPrices";
import CSRWrapper from "../CSRWrapper";
import PriceDisplayTransitionWrapper from "./PriceDisplayTransitionWrapper";

// 1. Accept details like mpvId, requestor, displayStrategy, selections (optionally), quantity (optionally) or quantityEnum (optionally),
// 2. Pass the details to PriceExtractionWrapper via PriceDisplayTransitionWrapper

export interface PriceDisplayProps extends PriceQuery {
  priceDisplayStrategy?: PricePresentationType;
  isQuantitySliderEnabled?: boolean;
  defaultPricingInfo?: PricingInfo;
  hideSetupFee?: boolean;
  hidePerUnitPrice?: boolean;
  hideVolumeDiscount?: boolean;
  hideMinimumOrderableQuantity?: boolean;
  alwaysShowMOQInfo?: boolean; //The prop will enable to show "No minimum quantity" when MOQ=1 if true

  //props introduced for PriceDisplayV2, to avoid breaking changes for existing implementations of PriceDisplay
  productId?: string; // Alias for productKey, as PriceDisplayV2 uses productId naming
  requestedPriceDisplayStrategy?: PriceDisplayType; // Alias for priceDisplayStrategy, as PriceDisplayV2 uses requestedPriceDisplayStrategy naming
  developmentMode?: boolean;
  alignVAT?: AlignVAT;
  isTile?: boolean;
  alternateSelections?: SelectionsWithQuantity;
  displayVariant?: DisplayVariant; //enum for pricing displays. If passed as from, it will showcase price in the form of "From xx"
}

const PriceDisplay = (props: PriceDisplayProps) => {
  return (
    // CSRWrapper added to avoid hydration error glitches for SSR rendered pages
    <CSRWrapper>
      <PriceDisplayTransitionWrapper {...props} />
    </CSRWrapper>
  );
};

export default PriceDisplay;
